<script lang="ts">
  import ButtonGroup from "../spend-report/ButtonGroup.svelte";
  import RadioButton from "../RadioButton.svelte";
  import { filteringDateChoices, type DatePickerStore } from "../../stores/date-picker";
  import DatePicker from "./DatePicker.svelte";
  import { filteringDate } from "../../helpers/store";
  import { DateFilterType } from "../../helpers/types";
  import { noop } from "../../helpers/utils";
  import { t } from "../../helpers/translations";

  export let datePickerStore: DatePickerStore;
  export let hideFilteringDate: boolean = false;
  $: filteringDateDisplay = hideFilteringDate
    ? undefined
    : filteringDateChoices.find((x) => $filteringDate === x.value)?.display;
  export let dateRangeFilters: DateFilterType[];

  const {
    isPast7DaysRange,
    isPast14DaysRange,
    isPast30DaysRange,
    isLastWeekDateRange,
    isThisMonthDateRange,
    isLastMonthDateRange,
    isLastQuarterDateRange,
    dateRangeDisplay,
    setPast7DaysDateRange,
    setPast14DaysDateRange,
    setPast30DaysDateRange,
    setLastWeekDateRange,
    setThisMonthDateRange,
    setLastMonthDateRange,
    setLastQuarterDateRange,
  } = datePickerStore;

  $: dateRangeButtonPropsByFilterType = {
    [DateFilterType.Past30Days]: {
      title: t("dateFilter.30days.title"),
      onClick: setPast30DaysDateRange,
      isActive: $isPast30DaysRange,
    },
    [DateFilterType.Past7Days]: {
      title: t("dateFilter.7days.title"),
      onClick: setPast7DaysDateRange,
      isActive: $isPast7DaysRange,
    },
    [DateFilterType.Past14Days]: {
      title: t("dateFilter.14days.title"),
      onClick: setPast14DaysDateRange,
      isActive: $isPast14DaysRange,
    },
    [DateFilterType.Week]: {
      title: t("dateFilter.lastWeek.title"),
      onClick: setLastWeekDateRange,
      isActive: $isLastWeekDateRange,
    },
    [DateFilterType.ThisMonth]: {
      title: t("dateFilter.thisMonth.title"),
      onClick: setThisMonthDateRange,
      isActive: $isThisMonthDateRange,
    },
    [DateFilterType.Month]: {
      title: t("dateFilter.lastMonth.title"),
      onClick: setLastMonthDateRange,
      isActive: $isLastMonthDateRange,
    },
    [DateFilterType.Quarter]: {
      title: t("dateFilter.lastQuarter.title"),
      onClick: setLastQuarterDateRange,
      isActive: $isLastQuarterDateRange,
    },
    [DateFilterType.Custom]: {
      title: "",
      onClick: noop,
      isActive: false,
    },
  };

  const { underlayAttrs, triggerElement } = datePickerStore;

  function handleDateSelect(date: Date) {
    datePickerStore.dispatch({
      type: "dateSelected",
      payload: date,
    });
  }

  function handleOpen() {
    datePickerStore.dispatch({
      type: "open",
    });
  }

  function handleDateChange(startDate: Date, endDate: Date) {
    datePickerStore.dispatch({
      type: "change",
      payload: {
        startDate,
        endDate,
      },
    });
  }

  function handleDateConfirm() {
    datePickerStore.dispatch({
      type: "confirm",
    });
  }
</script>

<div class="container">
  <ButtonGroup>
    {#each dateRangeFilters as filter}
      <RadioButton
        on:click={dateRangeButtonPropsByFilterType[filter].onClick}
        isActive={dateRangeButtonPropsByFilterType[filter].isActive}
      >
        {dateRangeButtonPropsByFilterType[filter].title}
      </RadioButton>
    {/each}
  </ButtonGroup>

  <DatePicker
    content={datePickerStore.datePickerContent}
    underlayAttrs={$underlayAttrs}
    dateRangeDisplay={$dateRangeDisplay}
    startDate={$datePickerStore.startDate}
    endDate={$datePickerStore.endDate}
    pickerState={$datePickerStore.state}
    onDateSelect={handleDateSelect}
    onOpen={handleOpen}
    onCancel={datePickerStore.onClose}
    onChange={handleDateChange}
    onConfirm={handleDateConfirm}
    {filteringDateChoices}
    {filteringDateDisplay}
    bind:filteringDate={$filteringDate}
    bind:triggerElement={$triggerElement}
  />
</div>

<style>
  .container {
    display: flex;
    gap: 4px;
    margin-left: 2px;
  }
</style>
